var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"small":"","target":"_blank","href":_vm.debuggerUrl,"disabled":!_vm.url,"depressed":""}},[_vm._v("FB Debugger")])}
var staticRenderFns = []

export { render, staticRenderFns }